import { render, staticRenderFns } from "./grid-router-link.vue?vue&type=template&id=5470e0cd"
import script from "./grid-router-link.ts?vue&type=script&lang=js&external"
export * from "./grid-router-link.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports